import { PROMOTION_SECTION_ID } from '../../../../constants/nodeIds';
import { Layout } from '../../../ServicePickerWidget/Layout';
import * as React from 'react';

export interface IPromotionLayoutProps {
  title: React.ReactElement;
  content: React.ReactElement;
}

export const PromotionLayout = ({ title, content }: IPromotionLayoutProps) => {
  return (
    <div id={PROMOTION_SECTION_ID}>
      <Layout>
        <Layout.Title>{title}</Layout.Title>
        <Layout.Content>{content}</Layout.Content>
      </Layout>
    </div>
  );
};
